import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cdc8b76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "areabox" }

import { onMounted, ref, watch } from 'vue'
import { regionData, codeToText } from 'element-china-area-data'
import { areaInfo } from '@/api/home'

interface AreaList {
  areaCode: number
  areaDepth: string
  areaName: string
  areaPy: string
  parentCode: number

  name: string
  id: number

}
//切换省份函数

export default /*#__PURE__*/_defineComponent({
  __name: 'citys',
  props: {
    gap: { default: '8' },
    width: { default: '200px' },
    addressCode: {},
    disabled: { type: Boolean, default: false },
    disabledArea: { default: {} }
  },
  emits: ['provinceCode', 'cityCode', 'countyCode'],
  setup(__props: any, { emit }) {

const prop = __props;


//抛出地址
// const emit = defineEmits<{
//   (
//     e: 'getAddress',
//     data: {
//       code: string[] | number[] //区域码
//       name: string[] //汉字
//       isComplete: boolean //是否选择完整，方便校验
//     }
//   ): void
// }>()





let address = ref<{
  province: string | number,
  city: string | number,
  area: string | number,
}>({
  province: '',
  city: '',
  area: '',
})


watch(() => prop.addressCode, (newV) => {

  if (newV) {
    address.value = {
      province: newV.province ? newV.province : '',
      city: newV.city ? newV.city : '',
      area: newV.area ? newV.area : '',
    }
  }
  // getProvinceList(0)

}, {
  // deep: true,
  immediate: true
})

onMounted(() => {

  getProvinceList(0)


})

const handleProvinceSelect = () => {
  address.value.city = ''
  address.value.area = ''
  console.log(address.value);
  getCityList(address.value.province)
  // emit('getAddress', {
  //   code: [Number(address.value.province)], //区域码
  //   name: [codeToText[address.value.province]], //汉字
  //   isComplete: false
  // })

  emit('provinceCode', address.value.province)
}
//切换城市函数
const handleCitySelect = () => {
  address.value.area = ''
  getAreaList(address.value.city)
  emit('cityCode', address.value.city)

  // emit('getAddress', {
  //   code: [Number(address.value.province), Number(address.value.city)], //区域码
  //   name: [codeToText[address.value.province], codeToText[address.value.city]], //汉字
  //   isComplete: areaList.value.length == 0 ? true : false
  // })
}
//切换地区函数
const handleAreaSelect = () => {
  emit('countyCode', address.value.area)

  // emit('getAddress', {
  //   code: [Number(address.value.province), Number(address.value.city), Number(address.value.area)], //区域码
  //   name: [codeToText[address.value.province], codeToText[address.value.city], codeToText[address.value.area]], //汉字
  //   isComplete: true
  // })
}

// 省级列表
const provinceList = ref<AreaList[]>([])
const getProvinceList = async (code: number | string) => {
  const { data } = await areaInfo(code)
  provinceList.value = data
  if (address.value.province) {
    getCityList(address.value.province)
  }
}
//二级城市列表
const cityList = ref<AreaList[]>([])
const getCityList = async (code: number | string) => {
  const { data } = await areaInfo(code)
  cityList.value = data
  if (address.value.city) {
    getAreaList(address.value.city)
  }
}
//三级地区列表
const areaList = ref<AreaList[]>([])
const getAreaList = async (code: number | string) => {
  const { data } = await areaInfo(code)
  areaList.value = data
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_select, {
      modelValue: _unref(address).province,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(address).province) = $event)),
      placeholder: "请选择省",
      style: _normalizeStyle({ width: `${prop.width}`, marginRight: `${prop.gap}px` }),
      onChange: handleProvinceSelect,
      disabled: _ctx.disabledArea.provinceDis,
      clearable: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinceList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: item.name,
            value: item.id
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "style", "disabled"]),
    _createVNode(_component_el_select, {
      modelValue: _unref(address).city,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(address).city) = $event)),
      placeholder: "请选择市",
      style: _normalizeStyle({ width: `${prop.width}`, marginRight: `${prop.gap}px` }),
      onChange: handleCitySelect,
      disabled: _ctx.disabledArea.cityDis,
      clearable: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: item.name,
            value: item.id
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "style", "disabled"]),
    _createVNode(_component_el_select, {
      modelValue: _unref(address).area,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(address).area) = $event)),
      placeholder: "请选择区",
      style: _normalizeStyle({ width: `${prop.width}` }),
      onChange: handleAreaSelect,
      disabled: _ctx.disabledArea.countryDis,
      clearable: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: item.name,
            value: item.id
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "style", "disabled"])
  ]))
}
}

})